import React from 'react';
import PropTypes from 'prop-types';
import CompletedBrainGames from './CompletedBrainGames';
import IncompleteBrainGames from './IncompleteBrainGames';
import phrasesType from '../../proptypes/phrases';

const BrainGames = ({
  nextBrainGamePath,
  numberOfPlayedChallenges,
  numberOfRemainingChallenges,
  phrases,
}) => (
  <article className="game-well-brain-games">
    {nextBrainGamePath ? (
      <IncompleteBrainGames
        nextBrainGamePath={nextBrainGamePath}
        numberOfPlayedChallenges={numberOfPlayedChallenges}
        numberOfRemainingChallenges={numberOfRemainingChallenges}
        phrases={phrases}
      />
    ) : (
      <CompletedBrainGames phrases={phrases} />
    )}
  </article>
);

BrainGames.propTypes = {
  nextBrainGamePath: PropTypes.string,
  numberOfPlayedChallenges: PropTypes.number.isRequired,
  numberOfRemainingChallenges: PropTypes.number.isRequired,
  phrases: phrasesType.isRequired,
};

BrainGames.defaultProps = {
  nextBrainGamePath: '',
};

export default BrainGames;
